import { Body, Controller, Post, Req } from '@nestjs/common';
import { UomsDTO } from './dto/uom.dto';
import { UomsService } from './uoms.service';
import { UomsResponseModel, AllUomsResponseModel } from '@gtpl/shared-models/masters';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { UomsRequest } from './dto/uoms.request';
import { UserRequestDto } from '../countries/dto/user-request-dto';
// import { UserRequestDto } from '@gtpl/shared-models/common-models';

@ApiTags('Uoms')
@Controller('Uoms')
export class UomsController {
    constructor(
        private uomsService: UomsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,
    ) { }
    /**
     * create or update Uom
     * @param uomsDTO 
     * @param isUpdate 
     * @param request 
     */
    @Post('/createUom')
    async createUom(@Body() uomsDTO: UomsDTO, isUpdate: boolean = false, @Req() request: Request): Promise<UomsResponseModel> {
        try {
            return await this.uomsService.createUom(uomsDTO, false, request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(UomsResponseModel, error)

        }
    }
    /**
     * 
     * create or update Uom
     * @param uomsDTO 
     * @param request 
     */
    @Post('/updateUom')
    async updateUom(@Body() uomsDTO: UomsDTO, @Req() request: Request): Promise<UomsResponseModel> {
        try {
            return await this.uomsService.createUom(uomsDTO, true, request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(UomsResponseModel, error)
        }
    }
    /**
     * get All Uoms Details
     * @param request 
     */
    @Post('/getAllUoms')
    async getAllUoms(@Body() req?:UserRequestDto): Promise<AllUomsResponseModel> {
        try {
            return await this.uomsService.getAllUoms(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllUomsResponseModel, error)
        }
    }
    @Post('/getAllActiveUoms')
  async getAllActiveUoms(@Req() request: Request): Promise<AllUomsResponseModel> {
      try {
          return await this.uomsService.getAllActiveUoms();
      } catch (error) {
          return this.applicationExceptionhandler.returnException(AllUomsResponseModel, error)
      }
  }
    /**
    * Activate Or De-Activate Uoms
    * @param getSingleUoms UomsResponseModel 
    * @returns Value Uoms
    */
    @Post('/activateOrDeactivateUom')
    async activateOrDeactivateUom(@Body() uomReq: UomsRequest): Promise<UomsResponseModel> {
        try {
            return await this.uomsService.activateOrDeactivateUom(uomReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(UomsResponseModel, err);
        }
    }
    
    @Post('/getActiveUomById')
    async getActiveUomById(@Body() uomReq: UomsRequest): Promise<UomsResponseModel> {
        try {
            return await this.uomsService.getActiveUomById(uomReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(UomsResponseModel, err);
        }
    }
    
    // @Post('/getAllUomsDropDownData')
    // async getAllUomsDropDownData(): Promise<UomsDropDownResponseModel> {
    //     try {
    //         return await this.uomsService.getAllUomsDropDownData();
    //     } catch (err) {
    //         return this.applicationExceptionhandler.returnException(UomsDropDownResponseModel, err);
    //     }
    // }

}
